import type { ColumnInfo } from '@flixflow/shared';
import { apiFetch } from './client.js';

export const schemaApi = {
  listTables: (connectionId: string) =>
    apiFetch<string[]>(`/api/schema/${connectionId}/tables`),
  listColumns: (connectionId: string, table: string) =>
    apiFetch<ColumnInfo[]>(`/api/schema/${connectionId}/columns/${encodeURIComponent(table)}`),
};
